import React from 'react';
import { MUITableColumn } from 'components/shared/MUITable';
import { Stack, Typography, IconButton, Tooltip } from '@mui/material';
import { InventoryItemEntity } from './InventoryTable';
import { formatMoney } from '../../utils';
import { capitalizeFirstLetter } from 'formatters';
import { Edit } from '@mui/icons-material';

export function createTableColumns({ useHistory }: { useHistory: any }): MUITableColumn<InventoryItemEntity>[] {
  return [
    {
      header: 'Equipment',
      renderKey: 'equipment',
      renderCell: ({ year, make, model, description, vin, stockNumber }) => (
        <Stack
          sx={{
            width: '100%',
            alignItems: 'flex-start', // <-- this is the correct value
            textAlign: 'left', // <-- ensures Typography text is left-aligned
            borderRadius: '0.5rem',
          }}
        >
          {year || make || model ? (
            <Typography>{`${year ?? ''} ${make ?? ''} ${model ?? ''}`}</Typography>
          ) : (
            <Typography>Unknown</Typography>
          )}

          <Typography variant="body2" color="text.secondary">
            {stockNumber ? `#${stockNumber}` : ''}
            {stockNumber && vin ? ' | ' : ''}
            {vin ? `VIN: ${vin}` : ''}
          </Typography>
        </Stack>
      ),
    },
    {
      header: 'Condition',
      renderKey: 'condition',
      sortKey: 'condition',
      renderCell: ({ condition }) => <>{condition ? capitalizeFirstLetter(condition) : 'Used'}</>,
    },
    {
      header: 'Mileage',
      renderKey: 'mileage',
      sortKey: 'mileage',
      renderCell: ({ mileage }) => <>{mileage || mileage === 0 ? mileage.toLocaleString() : '-'}</>,
    },
    {
      header: 'List Price',
      renderKey: 'retailPrice',
      sortKey: 'retail_price',
      renderCell: ({ retailPrice }) => <>{retailPrice ? `$${formatMoney(retailPrice, 0)}` : ''}</>,
    },
    {
      header: 'Status',
      renderKey: 'status',
      sortKey: 'status',
      renderCell: ({ status }) => <>{status ? capitalizeFirstLetter(status) : 'Unknown'}</>,
    },
    {
      header: 'Actions',
      renderKey: 'equipmentId',
      renderCell: ({ equipmentId }) => (
        <Tooltip title="Update Equipment">
          <IconButton
            size="small"
            color="primary"
            className="icon-btn-bordered"
            onClick={e => {
              e.stopPropagation();
              useHistory.push(`/equipment/${equipmentId}`);
            }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
      ),
    },
  ];
}
